module.exports = __webpack_public_path__ + "static/media/work2.85439fd1.webp";